import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Box, Grid, Text, Spinner } from "@chakra-ui/react";
import { fetchLeads } from "../../api/lead/leadApi";
import { getLikeProperty } from "../../api/Property/propertyApi";
import { PropertyCard } from "./Card";
import { base_url } from "../../constants/constant";
import axios from "axios";
import { FormattedMessage } from "react-intl";

function ContactedProperties({ refetchSavedProperties }) {
  const auth = JSON.parse(localStorage.getItem("userData"));
  const [contactedProperties, setContactedProperties] = useState([]);
  const [loadingProperties, setLoadingProperties] = useState(true);

  const { data: leads, isLoading: leadsLoading, refetch } = useQuery({
    enabled: !!auth?.access_token,
    queryKey: ["ContactedProperties"],
    queryFn: () => fetchLeads({ userId: auth?.id }),
    select: (res) => res?.data?.records,
  });

  const { data: favoriteProperties } = useQuery({
    enabled: !!auth?.access_token,
    queryKey: ["PropertyLikes"],
    queryFn: () => getLikeProperty(auth?.id),
    select: (res) => res?.data?.records,
  });

  useEffect(() => {
    if (leads) {
      const fetchPropertyDetails = async () => {
        try {
          const propertyPromises = leads.map(async (lead) => {
            if (!lead?.propertyId) return null;
            try {
              const response = await axios.get(`${base_url}property-listings/${lead.propertyId}`, {
                headers: { "ngrok-skip-browser-warning": true },
              });
              return { ...response.data, leadId: lead?.id };
            } catch (error) {
              console.error(`Failed to fetch property ${lead.propertyId}:`, error);
              return null;
            }
          });
          const results = await Promise.all(propertyPromises);
          setContactedProperties(results.filter(p => p !== null));
        } catch (error) {
          console.error("Failed to fetch property details list:", error);
        } finally {
          setLoadingProperties(false);
        }
      };

      fetchPropertyDetails();
    }
  }, [leads]);

  const getFavoriteId = (propertyId) => {
    const favorite = favoriteProperties?.find((fav) => fav.Property.id === propertyId);
    return favorite ? [{ id: favorite.id }] : [];
  };

  return (
    <Box p={{ base: 2, md: 4 }}>
      <Text
        fontSize="xl"
        fontWeight="bold"
        pt={{ base: 5, md: 10 }}
        textAlign={{ base: "center", md: "left" }}
      >
        <FormattedMessage id="contactedProperties.title" defaultMessage="Contacted Properties" />
      </Text>
      {leadsLoading || loadingProperties ? (
        <Spinner />
      ) : (
        <Grid
          templateColumns="1fr"
          gap={{ base: 6, md: 4 }}
          mt={{ base: 2, md: 4 }}
        >
          {contactedProperties.map((property) => (
            <PropertyCard
              key={property.id}
              item={property}
              liked={getFavoriteId(property.id)}
              refetch={refetch}
              refetchSavedProperties={refetchSavedProperties}
              isContacted={true}
              leadId={property.leadId}
            />
          ))}
        </Grid>
      )}
      {contactedProperties.length === 0 && !loadingProperties && (
        <Text>
          <FormattedMessage id="contactedProperties.noContacted" defaultMessage="No contacted properties found." />
        </Text>
      )}
    </Box>
  );
}

export default ContactedProperties;
